import React from 'react';
import { useNavigate } from 'react-router-dom';
import NoteDeFrais from '../components/NoteDeFrais';
import NouveauRapport from '../components/NouveauRapport';
import storageManager from '../services/storageManager';
import { useMissionContext } from '../context/MissionContext';

export function NoteDeFraisPage() {
  const { user } = useMissionContext();
  const navigate = useNavigate();

  return (
    <div className="app">
      <NoteDeFrais inspecteurId={user ? user.id : null} onBack={() => navigate(-1)} />
    </div>
  );
}

export function NouveauRapportPage() {
  const { setMissions } = useMissionContext();
  const navigate = useNavigate();

  return (
    <div className="app">
      <NouveauRapport
        onSuccess={(mission) => {
          setMissions((prev) => {
            const next = [mission, ...prev];
            storageManager.saveMissions(next);
            return next;
          });
          navigate('/mission/' + encodeURIComponent(mission.id));
        }}
        onBack={() => navigate(-1)}
      />
    </div>
  );
}
